import { http } from 'connex-cds';

export default {
  listCustomers: ({ entityRef }) => http.get({ apiName: 'setup', path: `/${entityRef}/customers` }),
};
